import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const rows = [{
  sin: 'Horas planificando desde cero cada semana',
  con: '5 minutos. Todo listo.'
}, {
  sin: 'Drills repetidos sin progresión visible',
  con: '+150 drills graficados por nivel'
}, {
  sin: 'Grupos sin sistema claro',
  con: 'Estructura clara para cada nivel y objetivo'
}, {
  sin: 'Llueve y cancelás perdiendo el dinero',
  con: '10 clases teóricas listas para dar bajo techo'
}, {
  sin: 'Alumnos que cancelan a último momento y no pagás',
  con: 'Sistema de cobro mensual blindado incluido'
}, {
  sin: 'Trabajás 8 horas para cobrar por 6',
  con: 'Modelo de grupos que cuadruplica tu hora'
}, {
  sin: 'Sensación de improvisar siempre',
  con: 'Llegás a la cancha con todo resuelto'
}];
export function ComparisonTable() {
  return <section className="py-20 bg-white" data-id="element-44">
      <div className="max-w-5xl mx-auto px-4" data-id="element-45">
        <h3 className="text-3xl md:text-4xl font-display text-center text-charcoal mb-12" data-id="element-46">
          ¿Cuánto cuesta NO tenerlo?
        </h3>

        <div className="overflow-x-auto pb-4" data-id="element-47">
          <div className="min-w-[600px] bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-48">
            {/* Header */}
            <div className="grid grid-cols-2 divide-x divide-gray-200 border-b border-gray-200" data-id="element-49">
              <div className="p-6 bg-gray-50 text-center" data-id="element-50">
                <h4 className="text-xl font-bold text-gray-500" data-id="element-51">
                  Sin TENIS 360
                </h4>
              </div>
              <div className="p-6 bg-tennis-green text-center" data-id="element-52">
                <h4 className="text-xl font-bold text-white" data-id="element-53">Con TENIS 360</h4>
              </div>
            </div>

            {/* Rows */}
            <div className="divide-y divide-gray-100" data-id="element-54">
              {rows.map((row, i) => <div key={i} className="grid grid-cols-2 divide-x divide-gray-100 hover:bg-gray-50/50 transition-colors" data-id="element-55">
                  <div className="p-5 flex items-center gap-3" data-id="element-56">
                    <XIcon className="text-red-400 shrink-0" size={20} data-id="element-57" />
                    <span className="text-gray-600 font-medium" data-id="element-58">{row.sin}</span>
                  </div>
                  <div className="p-5 flex items-center gap-3 bg-tennis-green/5" data-id="element-59">
                    <CheckIcon className="text-tennis-green shrink-0" size={20} data-id="element-60" />
                    <span className="text-charcoal font-bold" data-id="element-61">{row.con}</span>
                  </div>
                </div>)}
            </div>
          </div>
          <div className="text-center text-sm text-gray-400 mt-2 md:hidden" data-id="element-62">
            ← Scroll to see full table →
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mt-12" data-id="element-63">
          <p className="text-2xl font-display text-charcoal" data-id="element-64">
            El lunes podés improvisar o entrar con todo resuelto. Vos decidís.
          </p>
        </motion.div>
      </div>
    </section>;
}